"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VENDOR_CREATION_TAB_COUNT = void 0;
exports.VENDOR_CREATION_TAB_COUNT = {
    PERSONALDETAILS: 0,
    CONTACTDETAILS: 1,
    CONTRACTDETAILS: 2,
};
